<script setup lang="ts">
import type { MenuItem } from 'primevue/menuitem';

const props = defineProps< { item: MenuItem }>();
</script>

<template>
  <div
    class="flex items-center w-full gap-2 h-10 px-2 py-2 text-left font-semibold cursor-pointer select-none touch-manipulation"
    :class="props.item.isRootItem ? 'text-lg' : 'text-sm'"
  >
    <template v-if="props.item.image">
      <img :src="props.item.image" class="size-5 rounded">
    </template>
    <template v-else-if="props.item.icon">
      <i :class="'text-primary p-menu-item-icon pi ' + props.item.icon"> </i>
    </template>
    <div>{{ props.item.label }}</div>
    <span v-if="item.items" class="pi pi-angle-down text-primary ml-auto"></span>
  </div>
</template>
